const TeamPlayersTypes = {
    GET_TEAM_PLAYERS_START:'GET_TEAM_PLAYERS_START',
    GET_TEAM_PLAYERS_SUCCESS:'GET_TEAM_PLAYERS_SUCCESS',
    GET_TEAM_PLAYERS_FAILED:'GET_TEAM_PLAYERS_FAILED',

}

export default TeamPlayersTypes